<template>
  <!-- 庫存/購買 -->
  <div class="md:mt-4">
    <div class="buyBtn flex mt-2 md:items-center flex-wrap">

      <p class="text-NotoSansRegular pr-3 md:pr-2 text-sm textColorRed whitespace-no-wrap w-full md:w-auto"
        v-if="purchasePenData.status !== 'DISCONTINUED' && purchasePenData.category_id !== 114">
        <span v-if="purchasePenData.in_stock > 0">※有庫存</span>
        <span v-if="purchasePenData.in_stock === 0 || purchasePenData.in_stock === null">※補貨中，暫時無法購買。</span>
      </p>

      <div class="flex flex-wrap w-full md:w-auto" v-if="purchasePenData.status !== 'DISCONTINUED' && purchasePenData.category_id !== 114">
        <a v-if="purchasePenData.status === 'DISCONTINUED'" class="w-full md:w-auto btn cannotbuyBtn cursor-default font-normal text-NotoSansRegular mb-2 sm:mb-0 text-center"
          >※已絕版 無法購買</a>

        <a v-if="isAddCartNow && purchasePenData.status !== 'DISCONTINUED' && purchasePenData.in_stock > 0"
          class="w-full md:w-auto btn cursor-pointer addCart addCartBtn font-normal text-NotoSansRegular mb-2 sm:mb-0 text-center whitespace-no-wrap"
          @click.prevent="addCart()">加入購物車
        </a>

        <a v-if="iShopNow && (purchasePenData.status !== 'DISCONTINUED' && purchasePenData.in_stock > 0) && (additionalForSubscribers.indexOf(purchasePenData.id.toString()) === -1 && purchasePenData.name.indexOf('續訂') === -1)"
          class="w-full md:w-auto btn cursor-pointer addCart insBuyBtn font-normal text-NotoSansRegular mb-2 sm:mb-0 text-center whitespace-no-wrap"
          @click.prevent="checkoutNow">立即結帳
        </a>

        <a v-if="isAddWish && purchasePenData.status !== 'DISCONTINUED' && !purchasePenData.is_favorite" @click="addWish(purchasePenData.id)"
          class="w-full md:w-auto btn addWishBtn cursor-pointer font-normal text-NotoSansRegular text-center whitespace-no-wrap"
          :class="{ isFavorite: purchasePenData.is_favorite }"
          >加入收藏
        </a>

        <a v-if="isAddWish && purchasePenData.status !== 'DISCONTINUED' && purchasePenData.is_favorite"
          class="w-full md:w-auto isFavorite btn addWishBtn cursor-pointer font-normal text-NotoSansRegular text-center whitespace-no-wrap"
          disabled
          >加入收藏
        </a>
      </div>

      <p v-if="purchasePenData.status === 'DISCONTINUED' && purchasePenData.category_id === 114">校園團購用書，如需購買請洽詢 02-26600608</p>

      <a v-if="purchasePenData.status === 'DISCONTINUED' || (selectedPlan && selectedPlan.status === 'DISCONTINUED' && selectedPlan.type === 'SUBSCRIPTION')"
        class="w-full md:w-auto btn addWishBtn cursor-pointer font-normal text-NotoSansRegular text-center whitespace-no-wrap"
        >產品已停售
      </a>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
import moment from 'moment'
import Cart from '@/components/modules/addCart'
import Bus from '@/components/modules/bus.js'
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'DetailBtns',

  props: {
    purchasePenData: {
      type: Object
    },
    activityData: {
      type: Object
    },
    all_events: {
      type: Array
    },
    isAddCartNow: {
      type: Boolean,
      default: true
    },
    iShopNow: {
      type: Boolean,
      default: true
    },
    isAddWish: {
      type: Boolean,
      default: true
    }
  },
  mixins: [
    Cart,
    sweetAlert
  ],
  data () {
    return {
      selectedPlan: '',

      // gift
      selectedGift: '',

      // 運送方式
      isRegisteredMail: false,

      // 起訖日期
      disabledDate (date) {
        // 當月，往後12個月
        // 2024/4/30行銷部要求修改
        return date < new Date().setMonth(new Date().getMonth() - 1) || date > new Date().setMonth(new Date().getMonth() + 12)
      },

      begin_at: null,
      end_at: null,

      downloadFiles: {
        lifePenFile: null,
        myVoiceFile: null,
        Mp3File: null,
        JLPTFile: null,
        uploadFile: null
      },

      // 驗證訂戶編號popup
      subscriberStatus: {
        isShow: false,
        isVerify: false,

        // 加購點讀筆
        isPurshasePen: false
      },

      // 限雜誌訂戶加購
      additionalForSubscribers: ['6743', '8848', '7944', '11175', '11174']
    }
  },
  computed: {
    dataType () {
      if (this.purchasePenData && this.purchasePenData !== null) {
        return this.purchasePenData.type
      } else {
        return null
      }
    }
  },
  watch: {
  },
  mounted () {
  },

  methods: {
    getData () {
      var bookPath
      if ((this.$route.name === 'previewBook' || this.$route.name === 'previewMagazine' || this.$route.name === 'previewPackage') && this.userRole === 'admin') {
        bookPath = `/product/${this.$route.params.id}?scope=preview`
      } else {
        bookPath = `/product/${this.$route.params.id}?scope=onSale`
      }

      axios.get(bookPath)
        .then((response) => {
          if (response.status === 200) {
            Bus.$emit('val', response.data.type)
            this.purchasePenData = response.data
            response.data.type === 'PLAN' ? this.selectedPlan = response.data.plan[0] : this.selectedPlan = ''

            this.downloadFiles.lifePenFile = this.purchasePenData.attaches.filter(item => item.type === 'LIVEPEN_FILE')
            this.downloadFiles.myVoiceFile = this.purchasePenData.attaches.filter(item => item.type === 'LIVEPEN_FILE_2')
            this.downloadFiles.Mp3File = this.purchasePenData.attaches.filter(item => item.type === 'MP3')
            this.downloadFiles.uploadFile = this.purchasePenData.attaches.filter(item => item.type === 'CONTENT_UPDATE')
            this.downloadFiles.JLPTFile = this.purchasePenData.attaches.filter(item => item.type === 'JLPT_TEST')

            if (response.data.type === 'PLAN' && this.purchasePenData.livepen && this.purchasePenData.livepen.id) {
              this.getPenData()
            }

            // 廣告商code
            this.setAdvertiserFunc(response.data.id, response.data.pricing)

            // ga4
            this.view_item(response.data)
          } else if (response.status === 404) {
            this.$router.push({ name: 'index' })
            this.alertPop('warning', '查無商品或商品已下架')
          }
        })
        .catch(() => {
          this.$router.push({ name: 'index' })
          this.alertPop('warning', '查無商品或商品已下架')
        })
    },
    setAdvertiserFunc (id, pricing) {
      // eslint-disable-next-line
      let newPricing = pricing ? pricing : 0
      this.likeProductCode(id, newPricing)
    },

    getEndTime () {
      if (this.selectedPlan.months) {
        let months = this.selectedPlan.months - 1
        if (this.begin_at) {
          let startDate = new Date(this.begin_at)
          let endDateMoment = moment(startDate).add(months, 'months')
          this.end_at = moment(endDateMoment).format('YYYY-MM')
        } else {
          this.end_at = null
        }
      }
    },
    compare (attr) {
      return function (a, b) {
        return a.sort > b.sort || a.type > b.type ? 1 : -1
      }
    },

    getSelectGift (getSelectGift) {
      this.selectedGift = getSelectGift
    },

    async addWish (id) {
      let wishData = { 'productID': id, 'unit': '1' }
      if (this.$store.state.auth.authorized) {
        this.$set(this.purchasePenData, 'is_favorite', true)

        axios.post(`/products/${id}/favorite`)
          .then(() => {
            this.getData()

            // 廣告商code
            this.dataType !== 'PLAN' ? wishData.price = this.purchasePenData.pricing : null
            this.dataType === 'PLAN' ? wishData.price = this.selectedPlan.pricing : null

            this.addWishCode(wishData)

            // ga4
            this.add_to_wishlist(this.purchasePenData)
          })

        this.$store.dispatch('isAddingWish', true)
      } else {
        this.alertPop('warning', '尚未登入')
      }
    },
    addCart () {
      // 加入購物車
      if (this.dataType === 'PLAN') {
        if (!this.begin_at || !this.end_at) {
          this.alertPop('warning', '尚未選擇起始日期')
        } else if (this.selectedGift.length !== this.selectedPlan.gift_num) {
          this.alertPop('warning', '尚未選擇贈品')
        } else if (this.selectedPlan !== '' && this.begin_at && this.end_at && this.selectedGift.length === this.selectedPlan.gift_num) {
          this.selectedPlan.link_id = this.purchasePenData.id
          this.selectedPlan.link_name = this.purchasePenData.name
          this.selectedPlan.begin_at = this.begin_at
          this.selectedPlan.end_at = this.end_at
          this.selectedPlan.selected_gifts = this.selectedGift

          // 數位板不給掛號費
          if (this.selectedPlan.is_digital) {
            this.selectedPlan.isRegisteredMail = false
          } else {
            this.selectedPlan.isRegisteredMail = this.isRegisteredMail
          }

          // 續訂方案檢查訂戶ID
          if (this.selectedPlan.name.indexOf('續訂') > -1 && !this.subscriberStatus.isVerify) {
            this.subscriberStatus.isShow = true
          } else {
            // 新訂戶
            // this.addShoppingList(this.selectedPlan)
            this.addMultipleToCart([this.selectedPlan])
            this.addCartCode({ 'productID': this.selectedPlan.id, 'unit': '1', 'price': this.selectedPlan.pricing })
          }

          // 加購點讀筆&HIW不加價
          if (this.subscriberStatus.isPurshasePen) {
            this.addMultipleToCart([this.selectedPlan, this.purchasePenData])
          }
        }
      } else if (this.dataType !== 'PLAN') {
        if (this.additionalForSubscribers.indexOf(this.purchasePenData.id.toString()) > -1 && !this.subscriberStatus.isVerify) {
          // 續訂戶點讀筆需驗證
          this.subscriberStatus.isShow = true
        } else {
          if (this.purchasePenData.gift_num === 0) {
            // 不需要選贈品
            // this.addShoppingList(this.purchasePenData)
            this.addMultipleToCart([this.purchasePenData])
            this.addCartCode({ 'productID': this.purchasePenData.id, 'unit': '1', 'price': this.purchasePenData.pricing })
          } else if (this.purchasePenData.gift_num > 0 && (this.selectedGift.length !== this.purchasePenData.gift_num)) {
            // 有贈品沒選
            this.alertPop('warning', '尚未選擇贈品')
            // this.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '尚未選擇贈品', type: 'alert' })
          } else if (this.purchasePenData.gift_num > 0 && (this.selectedGift.length === this.purchasePenData.gift_num)) {
            // 選擇商品數量相符
            // this.addShoppingList(this.purchasePenData, this.selectedGift)
            this.addMultipleToCart([this.purchasePenData])
            this.addCartCode({ 'productID': this.purchasePenData.id, 'unit': '1', 'price': this.purchasePenData.pricing })
          }
        }
      }
    },
    async checkoutNow () {
      // 立即結帳
      await this.addCart()
      this.$store.dispatch('routeRecord', { routeName: 'checkout' })

      if ((this.dataType !== 'PLAN' && this.purchasePenData.gift_num === 0) || (this.dataType !== 'PLAN' && (this.purchasePenData.gift_num > 0 && (this.selectedGift.length === this.purchasePenData.gift_num))) || (this.dataType === 'PLAN' && this.selectedPlan !== '' && this.begin_at && this.end_at && this.selectedGift.length === this.selectedPlan.gift_num)) {
        if (!this.authorized) {
          this.$router.push({ name: 'login' })
        } else {
          await this.$store.dispatch('getProfile')
          this.$router.push({ name: 'checkout' })
        }
      }
    },
    closeSubscribe () {
      // 關閉詢問框
      this.subscriberStatus.isShow = false
      this.subscriberStatus.isAskShow = false
    },
    verifySubscribe (verifySubscribe) {
      // 訂戶編號詢問
      this.subscriberStatus.isVerify = verifySubscribe

      verifySubscribe ? this.addCart() : null
    }
  }
}
</script>

<style lang="scss" scoped>
    .buyBtn {
      .btn {
        color: #ffffff;
        font-size: 16px;
        padding: .5em 1.8em;
        border-radius: 5px;
        margin: 0 .4rem;
        @media (max-width: 1024px) {
          // font-size: 14px;
          padding: .6em 1.8em;
        }
      }
      .addCartBtn {
        background-color: #D80303;
        color: #ffffff;
      }
      .insBuyBtn {
        background-color: #219653;
        color: #ffffff;
      }
      .addWishBtn {
        background-color: #BDBDBD;
        color: #ffffff;
      }
      .cannotbuyBtn {
        background-color: #e5e5e5;
        color: #5d5d5d;
      }
      .chooseBtn {
        width: 120px;
        height: 38px;
        background-color: white;
        border: 1px solid #e60012;
        color: #e60012;
        font-size: 14px;
        margin: 0 .2rem;
        position: relative;
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          white-space: nowrap;
        }
        &:active {
          span {
            transform: translate(-50%, -45%);
          }
        }
      }
      .isFavorite {
        background-color: #e60012;
        color: white;
        cursor: default !important;
      }
    }
    .input-class {
      display: inline-block;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
      height: 38px;
      padding-left: 0.5rem;
      font-size: 14px;
      line-height: 1.4;
      color: #555;
      background-color: #fff;
      border: 1px solid #a0aec0;
      border-radius: 4px;
      -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    }
</style>
